__turbopack_context__.v({
  "menuWrapper": "GlobalMenu-module-scss-module__qAMGbW__menuWrapper",
});
